import React, { useState } from "react";
import {
    Col,
    Row,
    Card,
    CardBody,
    Modal,
    ModalBody,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import ResaleService from "services/Website/ResaleService"
import PropertyService from "services/Website/PropertyService"
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import CompoundService from "services/Website/CompoundService";

const MessageModal = ({ modal, setModal, item, type}) => {
    const { t } = useTranslation();
    const AuthData = useSelector(state => state.Auth);
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')
    const propertyService = new PropertyService()
    const compoundService = new CompoundService()

    const handleValidSubmit = (e, v) => {
        setLoading(true)
        if (type === "compound") {
            const data = {
                comment: v.message,
                compound_id: item.id,
                attattachment:item?.images?.length > 0 ?item.images.map(img=>img.path) :[]
            }
            compoundService.sendCil(data).then(res => {
                if (res && res.status === SuccessOk) {
                    toast.success("Message Sent successfully")
                    setModal(false)
                }
                setLoading(false)
            })
        } else {
            const data = {
                comment: v.message,
                unit_id:item.id,
                attattachment:item?.images?.length > 0 ?item.images.map(img=>img.path) :[]
            }
            propertyService.sendCil(data).then(res => {

                if (res && res.status === SuccessOk) {
                    toast.success("Message Sent successfully")
                    setModal(false)
                } 
                setLoading(false)
            })
        }
    }

    return (
        <Modal
            isOpen={modal}
            toggle={() => setModal(false)}
            style={{ maxWidth: '600px', marginTop: "10%", width: '100%' }}
            className={`${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}
        >
            <ModalBody className="m-0 p-0 fw-bold">
                <Card className='overflow-hidden m-0 p-0' style={{ direction: "inherit" }}>
                    <CardBody className=' p-0 m-0'>
                        <Row className="m-4 fw-bold font-size-16" >
                            {t("Message Sales Rep")}
                        </Row>
                             {type == 'unit' && <Row className="mx-4">
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("Unit Code")}</Row>
                                    <Row className="fw-bold">
                                        {item?.name[`${AuthData.lang}`] ? item?.name[`${AuthData.lang}`] : item?.name.en}
                                    </Row>
                                </Col>
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("location")}</Row>
                                    <Row className="fw-bold">
                                        {item?.area[`${AuthData.lang}`] ? item?.area[`${AuthData.lang}`] : item?.area?.en}
                                    </Row>
                                </Col>
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("beds")}</Row>
                                    <Row className="fw-bold">{item ?.bedrooms}</Row>
                                </Col>
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("Size")}</Row>
                                    <Row className="fw-bold">{parseInt(item ?.size).toFixed(0)} {t("sqm")}</Row>
                                </Col>
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("price")}</Row>
                                    <Row className="fw-bold">{toCurrency(item ?.price)} {t("egp")}</Row>
                                </Col>
                                <Col md={3} className="my-2 ">
                                    <Row className="font-size-14 text-muted">{t("Unit Type")}</Row>
                                    <Row className="fw-bold"> {item ?.unit_types[`${AuthData.lang}`] ? item ?.unit_types[`${AuthData.lang}`] : item ?.unit_types?.en}</Row>
                                </Col>
                             </Row>}
                        <Row className="my-4 mx-2 fw-bold font-size-16">
                            <AvForm
                                className='form-horizontal'
                                onValidSubmit={(e, v) => {
                                    handleValidSubmit(e, v)
                                }}>
                                <AvField
                                    name='message'
                                    label="Message"
                                    placeholder='Type Message'
                                    className='form-control'
                                    type="textarea"
                                    bsSize="lg"
                                />
                                <Row className="mt-4">
                                    <Col md={9}></Col>
                                    <Col md={3}>
                                        <button
                                            className="btn btn-success btnHeight px-4 float-end"
                                            disabled={loading}
                                        >{t("Submit")}</button>
                                    </Col>
                                </Row>
                            </AvForm>
                        </Row>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    )
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}
export default MessageModal